import type {
  AdminUserAction,
  AdminUserDetail,
  AdminUserEmailDraft,
  AdminUserEmailPreview,
  AdminPublisherRelease,
  AdminUsersPage,
  AdminUsersQuery,
  DeletedAccountArchive,
  DeletedAccountArchiveSummary,
} from '../types/adminUsers';
import { http } from './http';

export const adminUsersApi = {
  list(input: AdminUsersQuery): Promise<AdminUsersPage> {
    const query = new URLSearchParams({
      search: input.query,
      page: String(input.page),
      limit: String(input.limit),
    });
    return http.get(`/admin/users?${query}`);
  },
  detail(id: string): Promise<AdminUserDetail> {
    return http.get(`/admin/users/${encodeURIComponent(id)}`);
  },
  deletedAccounts(): Promise<DeletedAccountArchiveSummary[]> {
    return http.get('/admin/deleted-accounts');
  },
  deletedAccount(id: string): Promise<DeletedAccountArchive> {
    return http.get(`/admin/deleted-accounts/${encodeURIComponent(id)}`);
  },
  publisherReleases(id: string): Promise<AdminPublisherRelease[]> {
    return http.get(`/admin/users/${encodeURIComponent(id)}/publisher-releases`);
  },
  create(email: string, password: string, adminPassword: string): Promise<AdminUserDetail> {
    return http.post('/admin/users', { email, password, adminPassword });
  },
  remove(id: string, password: string): Promise<void> {
    return http.delete(`/admin/users/${encodeURIComponent(id)}`, { password });
  },
  act(id: string, action: AdminUserAction, password: string): Promise<AdminUserDetail> {
    return http.post(`/admin/users/${encodeURIComponent(id)}/actions`, { action, password });
  },
  previewEmail(id: string, draft: AdminUserEmailDraft): Promise<AdminUserEmailPreview> {
    return http.post(`/admin/users/${encodeURIComponent(id)}/email/preview`, draft);
  },
  async sendEmail(id: string, draft: AdminUserEmailDraft): Promise<void> {
    await http.post(`/admin/users/${encodeURIComponent(id)}/email`, draft);
  },
};
